import { render } from "./NotificationAlert.vue?vue&type=template&id=4df6c1c0&scoped=true"
import script from "./NotificationAlert.vue?vue&type=script&lang=js"
export * from "./NotificationAlert.vue?vue&type=script&lang=js"

import "./NotificationAlert.vue?vue&type=style&index=0&id=4df6c1c0&scoped=true&lang=css"

import exportComponent from "/home/innovation/Documents/project/for small pos/BioLab/clientnew/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df6c1c0"]])

export default __exports__